import styled from "styled-components";
import { media } from "../../../../utils";

export const SectionHeader = styled.div`
  background: #500778;
  color: ${({ theme }) => theme.color.line.light};
`;

export const AccordionTitle = styled.span`
  text-align: center;
  &:not(:first-of-type) {
    margin-top: 24px;
  }
  ${media.md()} {
    text-align: left;
    color: #500778;
  }
  ${media.lg()} {
    &:not(:first-of-type) {
      margin-top: 60px;
    }
  }
`;

export const AccordionContainer = styled.div`
  ${media.md()} {
    display: flex;
    justify-content: space-between;

    > div {
      width: 45%;
    }
  }
`;
